import React from 'react';
import DashboardKpiStatus from "components/DashboardKpiStatus";
import { CiCalendar } from "react-icons/ci";
import { Card, CardContent, Grid, Typography, Avatar, Box, Alert } from "@mui/material";
import { VscPercentage } from "react-icons/vsc";
import { mapScheduleKpis } from 'view/dashboard/schedule/scheduleKpiMapper';
import { projectKpis } from './mapper';

const formatDate = (date) => {
    if (!date) return "-";
    const d = new Date(date);
    return d.toLocaleDateString("en-GB", {
        day: "2-digit",
        month: "short",
        year: "numeric",
    }); // 21 Nov 2024
};

const formatCrore = (value) => {
    if (value === null || value === undefined || isNaN(value)) {
        return "₹ 0.00 Cr";
    }
    const num = Number(value); // or divide by 10000000 if backend sends rupees
    return `₹ ${num.toFixed(2)} Cr`;
};

const Kpis = ({ scheduelKpi, isLoading, scheduleKpiError, customer }) => {
    // const row = kpiData?.data?.[0];
    // if (!row) return null;
    let kpiData = []
    if (customer?.title == 'Safexpress') {
        kpiData = projectKpis({
            ...scheduelKpi?.data?.[0],
            actualProgress: 1,
            planProgress: 1.5,
            projectStartDate: "2026-05-06T00:00:00",
            projectEndDate: "2027-01-25T00:00:00",
            projectProjectedEndDate: "2027-01-25T00:00:00"
        });
    } else {
        kpiData = projectKpis(scheduelKpi?.data?.[0]);
    }

    const isTotallyEmpty = kpiData?.length === 0 && !isLoading;

    return (
        <Card
            elevation={0}
            sx={{
                borderRadius: "3px",
                border: "1px solid #eef0f4",
                p: 1.5,
                width: "100%",
                maxHeight: { md: "330px", xs: "auto" },
                boxSizing: "border-box"
            }}
        >
            <Typography
                variant="subtitle1"
                sx={{
                    fontFamily: "Outfit, sans-serif",
                    fontWeight: 600,
                    fontSize: "15px",
                    lineHeight: "21px",
                    letterSpacing: "0px",
                    mb: "4px",
                }}
            >
                Customer Delivery Signals
            </Typography>
            <Typography
                sx={{
                    fontFamily: "Outfit, sans-serif",
                    fontWeight: 300,
                    fontSize: "12px",
                    lineHeight: "21px",
                    letterSpacing: "0px",
                    mb: "20px",
                }}
            >
                Track key metrics to understand progress and risk.
            </Typography>

            <Grid container rowSpacing={1} columnSpacing={4.5} sx={{ flexWrap: "nowrap", overflowX: "auto" }}>
                {kpiData?.map((item) => (
                    <Grid xs={12} sm={6} md={12 / 7} key={item.label} sx={{ flex: "0 0 auto", minWidth: 200 }} >
                        <Card
                            elevation={0}
                            sx={{
                                height: "128px",
                  position: "relative",
                                // width: { minWidth: "200px", minWidth: "100%" },

                                borderRadius: "3px",
                                backgroundColor: "#FFFFFF",
                  border: "1px solid #E2E8F0",
                  borderBottom: `3px solid ${item.iconBg}`,
                            }}
                        >
                            <CardContent sx={{ gap: 1, p: 1.25, pt: 1.25 }}>
                                <Avatar
                                    sx={{
                                        width: 30,
                                        height: 30,
                                        backgroundColor: item.iconBg,
                                        fontSize: 18,
                                        fontWeight: 700,
                                    }}
                                >
                                    {item.type === "percentage" ? <VscPercentage /> : <CiCalendar />}
                                </Avatar>
                  <DashboardKpiStatus color={item.iconBg} />

                                {/* 🔽 THIS BLOCK IS NOW CONDITIONAL */}
                                {item.type === "progress" ? (
                                    <>
                                        {/* Actual vs Plan text */}
                                        <Box
                                            sx={{
                                                display: "flex",
                                                alignItems: "baseline",
                                                gap: 1,
                                                mt: "4px",
                                            }}
                                        >
                                            <Typography
                                                sx={{
                                                    fontFamily: "Outfit, sans-serif",
                                                    fontWeight: 700,
                                                    fontSize: "16px",
                                                    lineHeight: "21px",
                                                    color: "#151D48",
                                                }}
                                            >
                                                {item.actual} {item.unit}
                                            </Typography>
                                            <Typography
                                                sx={{
                                                    fontFamily: "Outfit, sans-serif",
                                                    fontWeight: 500,
                                                    fontSize: "12px",
                                                    lineHeight: "18px",
                                                    color: "#667085",
                                                }}
                                            >
                                                of {item?.plan?.toFixed(2)} {item?.unit} {item?.planDisplayText}
                                            </Typography>
                                        </Box>

                                        {/* Mini progress bar */}
                                        <Box sx={{ mt: 1.5 }}>
                                            <Box
                                                sx={{
                                                    height: 6,
                                                    borderRadius: 999,
                                                    backgroundColor: "#E4E7EC",
                                                    overflow: "hidden",
                                                }}
                                            >
                                                <Box
                                                    sx={{
                                                        width: `${Math.min(
                                                            (item?.actual / (item?.plan || 1)) * 100,
                                                            100
                                                        )}%`,
                                                        height: "100%",
                                                        borderRadius: 999,
                                                        background:
                                                            item?.actual >= item?.plan
                                                                ? "#12B76A"
                                                                : "#1073F6",
                                                        transition: "width 0.3s ease",
                                                    }}
                                                />
                                            </Box>

                                            {/* Delta text */}
                                            <Typography
                                                sx={{
                                                    mt: 0.5,
                                                    fontFamily: "Outfit, sans-serif",
                                                    fontWeight: 500,
                                                    fontSize: "12px",
                                                    color:
                                                        item.actual >= item.plan
                                                            ? "#12B76A"
                                                            : "#F04438",
                                                }}
                                            >
                                                {item.actual >= item.plan
                                                    ? `${Math.abs(item.actual - item.plan).toFixed(2)} ${item.unit} ahead`
                                                    : `${Math.abs(item.actual - item.plan).toFixed(2)} ${item.unit} behind`}
                                            </Typography>
                                        </Box>

                                        {/* Label */}
                                        <Typography
                                            sx={{
                                                fontFamily: "Outfit, sans-serif",
                                                fontWeight: 500,
                                                lineHeight: "16px",
                                                fontSize: "12px",
                                                letterSpacing: "0px",
                                                color: "#425166",
                                                mt: "4px",
                                            }}
                                        >
                                            {item.label}
                                        </Typography>
                                    </>
                                ) : (
                                    <>
                                        {/* Default layout for other KPI types */}
                                        <Box
                                            sx={{
                                                display: "flex",
                                                flexDirection: "row",
                                                alignItems: "center",
                                                gap: "13px",
                                                mt: "4px",
                                            }}
                                        >
                                            <Typography
                                                sx={{
                                                    fontFamily: "Outfit, sans-serif",
                                                    fontWeight: 700,       // highlight the value
                                                    fontSize: "16px",
                                                    lineHeight: "21px",
                                                    color: item.type === "percentage" ? "#FF383C" : "#151D48",
                                                    // mt: "12px",            // more breathing room
                                                    // mb: "4px",
                                                }}
                                            >
                                                {item.type === "date" ? formatDate(item.value) : item.type === "percentage" ? `${formatCrore(item.value)}` : item.value} {item.unit}
                                            </Typography>
                                            {item?.subText && (
                                                <Typography
                                                    sx={{
                                                        fontFamily: "Outfit, sans-serif",
                                                        fontWeight: 500,
                                                        lineHeight: "16px",
                                                        fontSize: "12px",
                                                        color: "#425166",
                                                    }}
                                                >
                                                    {item.subText}

                                                </Typography>
                                            )}

                                        </Box>
                                        {item.type === "cost" && (

                                            item?.subTexts?.map(subItem => <>
                                                <Typography
                                                    variant="body2"
                                                    sx={{
                                                        fontFamily: "Outfit, sans-serif",
                                                        fontWeight: 400,
                                                        fontSize: "12px",
                                                        color: "#4B5563",
                                                    }}
                                                >
                                                    {subItem?.label}:{" "}
                                                    <strong>{formatCrore(subItem?.value)}</strong>
                                                </Typography></>)


                                        )}



                                        <Typography
                                            sx={{
                                                fontFamily: "Outfit, sans-serif",
                                                fontWeight: 500,
                                                lineHeight: "16px",
                                                fontSize: "12px",
                                                letterSpacing: "0px",
                                                color: "#425166",
                                                mt: "4px",
                                            }}
                                        >
                                            {item.label}
                                        </Typography>

                                    </>
                                )}
                            </CardContent>
                        </Card>
                    </Grid>
                ))}
                {isTotallyEmpty && (
                    <Grid item sx={{ flex: "0 0 auto", display: 'flex', alignItems: 'center', px: 3 }}>
                        <div>No KPIs to show</div>
                    </Grid>
                )}
                {isLoading && (
                    <Grid item sx={{ flex: "0 0 auto", display: 'flex', alignItems: 'center', px: 3 }}>
                        <Box>Loading KPIs...</Box>
                    </Grid>
                )}
                {isTotallyEmpty && scheduleKpiError && (
                    <Grid item xs={12}>
                        <Box>
                            Unable to load kpi metrics. Please refresh the page.
                        </Box>
                    </Grid>
                )}
            </Grid>
        </Card>
    )
}

export default Kpis
